import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { useSubscription } from '@/hooks/useSubscription';
import { useCartStore } from '@/stores/cartStore';
import UserChip from './UserChip';

export default function Topbar() {
  const { user, loading } = useAuth();
  const { isAdmin } = useIsAdmin();
  const { isActive } = useSubscription();
  const cartLines = useCartStore((s) => s.lines.length);

  return (
    <header className="topbar">
      <Link to="/" className="brand">
        <div className="brand-mark">SW</div>
        <div className="brand-name">
          SLIGHTLY WICKED
          <small>CUSTOMS / EST. MMXXVI</small>
        </div>
      </Link>

      <nav className="topbar-nav">
        <NavLink to="/" end className={({ isActive: a }) => (a ? 'active' : '')}>
          Home
        </NavLink>
        <NavLink to="/pricing" className={({ isActive: a }) => (a ? 'active' : '')}>
          Pricing
        </NavLink>
        {user && (
          <a href="https://dragracearchive.com" target="_blank" rel="noopener noreferrer">
            Drag Race Archive
          </a>
        )}
        {isActive && (
          <>
            <NavLink to="/inventory" className={({ isActive: a }) => (a ? 'active' : '')}>
              Inventory
            </NavLink>
            <NavLink to="/vehicles" className={({ isActive: a }) => (a ? 'active' : '')}>
              Vehicles
            </NavLink>
            <NavLink to="/orders" className={({ isActive: a }) => (a ? 'active' : '')}>
              Orders
            </NavLink>
            {cartLines > 0 && (
              <NavLink to="/quote" className={({ isActive: a }) => (a ? 'active' : '')}>
                Quote ({cartLines})
              </NavLink>
            )}
          </>
        )}
        {isAdmin && (
          <NavLink to="/admin" className={({ isActive: a }) => (a ? 'active' : '')}>
            Admin
          </NavLink>
        )}
      </nav>

      <div className="topbar-actions">
        {loading ? null : user ? (
          <UserChip user={user} />
        ) : (
          <Link to="/signin" className="btn ghost sm">
            Sign In
          </Link>
        )}
      </div>
    </header>
  );
}
